import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import NotificationModal from "../../components/modal/NotificationModal.tsx";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "../../store/modules/notification.ts";
import { useEffect } from "react";
export function NotificationProvider() {
    const notificationState = useSelector((state) => state.notification);
    const dispatch = useDispatch();
    useEffect(() => {
        console.log('notified');
    }, [notificationState.modal.show]);
    return (_jsx(_Fragment, { children: _jsx(NotificationModal, { onClose: () => dispatch(notification.mutation.closeModal()), type: notificationState.modal.type, title: notificationState.modal.title, body: notificationState.modal.body, show: notificationState.modal.show }) }));
}
